export default "__VITE_ASSET__92685e83__"